import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroSectionComponent } from '../../app/components/hero-section/hero-section.component';
import { LocationBannerComponent } from '../../app/components/location-banner/location-banner.component';
import { NearbyClassesComponent } from '../../app/components/nearby-classes/nearby-classes.component';
import { NearbyEventsComponent } from '../../app/components/nearby-events/nearby-events.component';
import { NearbyWorkshopsComponent } from '../../app/components/nearby-workshops/nearby-workshops.component';
import { PopularEventsComponent } from '../../app/components/popular-events/popular-events.component';
import { NewsletterComponent } from '../../app/components/newsletter/newsletter.component';

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    CommonModule,
    HeroSectionComponent,
    LocationBannerComponent,
    NearbyClassesComponent,
    NearbyEventsComponent,
    NearbyWorkshopsComponent,
    PopularEventsComponent,
    NewsletterComponent,
  ],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent {}
